import * as yup from 'yup';

export const contactFormSchema = yup.object().shape({
    full_name: yup
        .string()
        .required('Full Name is required')
        .min(3, 'Full Name must be at least 3 characters long')
        .max(255, 'Full Name cannot exceed 255 characters'),

    phone_code: yup
        .string()
        .required('Phone code is required')
        .max(10, 'Phone code cannot exceed 10 characters')
        .matches(/^\+?[0-9]+$/, 'Phone code must contain only numbers'),

    phone_number: yup
        .string()
        .required('Phone Number is required')
        .min(7, 'Phone Number must be at least 7 digits')
        .max(20, 'Phone Number cannot exceed 20 characters')
        .matches(/^[0-9]+$/, 'Phone Number must contain only numbers'),

    email: yup
        .string()
        .required('Email is required')
        .email('Please enter a valid email address')
        .max(255, 'Email cannot exceed 255 characters'),

    message: yup
        .string()
        .required('Message is required')
        .min(10, 'Message must be at least 10 characters long')
        .max(1000, 'Message cannot exceed 1000 characters'),
});
